<template>
  <div ref="workHourDistChart" class="chart-container"></div>
</template>

<script>
import * as echarts from 'echarts'
import { getWorkHourDistribution } from "../api";
import { extractTitleAndValueArrays } from "@/basic-common/util/common";

export default {
  inject: ['parentThat'],
  mounted () {
    this.initChart()
  },
  methods: {
    initChart () {
      const chartDom = this.$refs.workHourDistChart
      const myChart = echarts.init(chartDom)
      const { queryForm } = this.parentThat
      getWorkHourDistribution(queryForm).then(({ data }) => {
        const dataAll = extractTitleAndValueArrays(data.data, 'teamName', 'totalWorkHours')
        this.setOption(myChart, dataAll.values, dataAll.titles)
      })
    },
    setOption (myChart, data, title) {
      const option = {
        title: {
          text: '工时分布',
          left: '10%',
          top: '5%'
        },
        xAxis: {
          type: 'category',
          data: title
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: data,
            type: 'bar'
          }
        ]
      }
      myChart.setOption(option)
    }
  }
}
</script>

<style scoped>
.chart-container {
  width: 100%;
  height: 100%;
}
</style>